/**
 * The exit rule every runtime map overlay of the Promet section follows
 * (docs/modules/maplibre/LAYER-ORDERING-CRITICAL.md): it leaves by removing its
 * layers AND its source. Shared by NgPrometZoneOverlay and NgPrometSensorOverlay.
 *
 * The entry rule — insert under the 3D buildings — is `firstExtrusionLayerId`
 * in `src/client/map/overlayLayers.ts`, shared with every other overlay.
 */

import type maplibregl from 'maplibre-gl';

/** Layers first, then the source (a source in use cannot be removed). */
export function removeOverlay(map: maplibregl.Map, layerIds: readonly string[], sourceId: string): void {
  if (!map.getStyle()) return;
  for (const id of layerIds) {
    if (map.getLayer(id)) map.removeLayer(id);
  }
  if (map.getSource(sourceId)) map.removeSource(sourceId);
}
